import { render, staticRenderFns } from "./Event-cards.vue?vue&type=template&id=51f455af&"
import script from "./Event-cards.vue?vue&type=script&lang=js&"
export * from "./Event-cards.vue?vue&type=script&lang=js&"
import style0 from "./Event-cards.vue?vue&type=style&index=0&id=51f455af&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports